import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {InventoryBarcodeSearchModel} from "../inventory-barcode-search.model";
import {InventoryBarcodeEntityModel} from "../inventory-barcode-entity.model";

@Component({
    selector: "wbo-inventory-barcode-search-page",
    templateUrl: "./inventory-barcode-search-page.component.html",
    providers: [provideSearchModel(InventoryBarcodeSearchModel), provideEntityModel(InventoryBarcodeEntityModel)]
})
export class InventoryBarcodeSearchPageComponent extends AbstractSearchPage {

    constructor() {
        super();
    }
}
